/** Operasyon "Transfer" sekmesinin metinleri (09.10.2026). */
export const TRANSFER = {
  tab: 'Transfer',
  title: 'Transfer işleri',
  intro: 'Özel transferler, alış saatine göre. Şoförü atayın, iş bitince tamamlayın.',
  refresh: 'Yenile',
  loading: 'Transfer işleri yükleniyor…',
  loadError: 'Transfer işleri yüklenemedi. Yeniden deneyin.',
  empty: 'Bu görünümde transfer işi yok',
  emptyHint: 'Ödenmiş transfer siparişleri geldiğinde burada görünür. Süzgeçleri de kontrol edin.',
  states: { OPEN: 'Açık işler', PENDING: 'Bekliyor', DRIVER_ASSIGNED: 'Şoför atandı', COMPLETED: 'Tamamlandı', CANCELLED: 'İptal', ALL: 'Hepsi' },
  stateName: { PENDING: 'Bekliyor', DRIVER_ASSIGNED: 'Şoför atandı', COMPLETED: 'Tamamlandı', CANCELLED: 'İptal' },
  filters: {
    search: 'Ara', searchPlaceholder: 'Yolcu, sipariş, telefon, uçuş, nokta, şoför veya plaka',
    range: 'Tarih aralığı', rangeEmpty: 'Tarih aralığı seçin', rangeHalf: 'Bitiş tarihini seçin', side: 'Yaka', airport: 'Havalimanı', leg: 'Ayak', sort: 'Sıralama',
    any: 'Hepsi', europe: 'Avrupa', anatolia: 'Anadolu', outbound: 'Gidiş', return: 'Dönüş',
    soonest: 'En yakın alış önce', latest: 'En uzak alış önce', clear: 'Süzgeçleri temizle',
  },
  cols: { when: 'Tarih ve saat', passenger: 'Yolcu', route: 'Güzergâh', vehicle: 'Araç ve yük', price: 'Satış fiyatı', status: 'Durum', driver: 'Şoför / plaka', action: 'İşlem' },
  side: { EUROPE: 'Avrupa yakası', ANATOLIA: 'Anadolu yakası' },
  leg: { OUTBOUND: 'Gidiş', RETURN: 'Dönüş' },
  flight: 'Uçuş',
  from: 'Alış', to: 'Bırakış',
  passengers: (n: number) => `${n} yolcu`,
  luggage: (n: number) => `${n} bagaj`,
  vehicleUnknown: 'Araç bilgisi yok',
  unknown: 'Belirtilmedi',
  detailMissing: 'Eksik bilgi',
  detailMissingHint: 'Sipariş alış saati veya noktaları taşımıyor. Müşteriyle görüşüp tamamlayın.',
  returnWithOutbound: 'Gidişle birlikte',
  noDriver: 'Atanmadı',
  open: 'Aç', close: 'Kapat',
  detail: { customerNote: 'Müşteri notu', opsNote: 'Operasyon notu', order: 'Sipariş', phone: 'Telefon', assignedBy: 'Atayan', completedBy: 'Tamamlayan' },
  form: { driver: 'Şoför adı', plate: 'Araç plakası', note: 'Operasyon notu', assign: 'Şoförü ata', reassign: 'Atamayı güncelle', unassign: 'Atamayı kaldır', complete: 'Tamamlandı olarak işaretle', saving: 'Kaydediliyor…' },
  saved: 'Kaydedildi.',
  results: (n: number, total: number) => `${n} iş gösteriliyor · Toplam ${total}`,
  prev: 'Önceki', next: 'Sonraki',
  errors: { DRIVER_REQUIRED: 'Önce şoför atayın.', NOT_STARTED_YET: 'Alış saati gelmeden tamamlanamaz.', WRONG_STATE: 'İşin durumu değişmiş. Listeyi yenileyin.' } as Record<string, string>,
} as const;
